import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CreateImg extends Component {
  render() {
    const { image } = this.props;
    if (!image) {
      return '-';
    }

    return (
      <img
        src={`${image.link_base}/${image.size}/${image.img_link}`}
        alt={image.alt}
      />
    );
  }
}

CreateImg.propTypes = {
  image: PropTypes.shape({
    size: PropTypes.string,
    img_link: PropTypes.string,
    link_base: PropTypes.string,
    alt: PropTypes.string,
  }),
};

CreateImg.defaultProps = {
  image: {
    size: 'o-n',
    img_link: null,
    link_base: null,
    alt: null,
  },
};

export default CreateImg;
